"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M4.907.008c-.72 0-1.18.487-1.18 1.397l-.001 4.283c-.001 2.099-.002 4.198-.001 6.298v10.8c0 .788.427 1.208 1.226 1.212.84.003 9.299.002 14.088 0 .799 0 1.232-.428 1.232-1.207v-4.47c0-4.47 0-8.941.004-13.412 0-.456-.14-.838-.436-1.184l-.259-.302c-.762-.89-1.524-1.779-2.264-2.686-.42-.516-.929-.741-1.598-.737C13.665.012 9.201.01 6.5.008H4.907Zm1.3 9.466.009 2.94h2.44V8.28s.37-.005-1.048-.005c-1.417 0-1.402 1.198-1.402 1.198Zm9.103-1.198v4.138h2.461l.004-.731v-.001c.004-.79.01-1.972.01-2.249v-.058c.003-.423.006-1.09-.939-1.09-.249 0-.498-.003-.75-.005-.258-.002-.519-.004-.786-.004Zm-9.091 8.827h2.48v4.138L7.16 21.23c-.227 0-.954-.022-.954-.894s.013-3.233.013-3.233Zm8.165 4.138v-4.138H12.42v4.138h1.964Zm-4.867-4.138h1.963v4.138H9.517v-4.138Zm4.867-8.827H12.42v4.138h1.964V8.276Zm-4.867 4.138V8.276h1.963v4.138H9.517Zm5.818 3.904v4.918s.074.005 1.283.005c1.209 0 1.175-.785 1.175-.785l-.006-6.939H6.207v2.801h9.128Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};